import Interceptor from "@/plugins/interceptor.js";

const urlAPI = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_GAME}`;

const Game = {
  state: {
    listGames: [],
    totalGames: 0,
    game: {},
    nextGames: []
  },
  actions: {
    search: async ({commit}, params) => {
      try {
        let url = `${urlAPI}/search?filter=${params.filters.like}&pageNumber=${params.pageNumber}`;
        if (params.filters.seasonId != null) url += `&seasonId=${Number(params.filters.seasonId)}`
        if (params.filters.matchday != null) url += `&matchday=${Number(params.filters.matchday)}`
        const response = await Interceptor.get(url);
        commit("SET_listGames", response.data.data)
        commit("SET_totalGames", response.data.totalResults)
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    getGame: async ({commit}, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/get?gameId=${params.gameId}`);
        commit("SET_game", response.data)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    gameGetNext: async ({commit}) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/gameGetNext`);
        commit("SET_nextGames", response.data)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    get4Update: async ({}, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/get4Update?id=${params.id}`)
        return response.data
      } catch (error) {
        console.error(error)
      }
    },
    update: async ({}, data) => {
      try {
        const response = await Interceptor.put(`${urlAPI}/update`, data)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    publish: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/publish`, params);
        return response
      } catch (error) {
        console.error(error)
      }
    },
    unpublish: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/unpublish?gameId=${params.gameId}`, {});
        return response
      } catch (error) {
        console.error(error)
      }
    },
    create: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/create`, params);
        return response
      } catch (error) {
        console.error(error)
      }
    },
    getStats: async ({}, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getStats?gameId=${params.gameId}`)
        return response
      } catch (error) {
        console.error(error)
      }
    }
  },
  mutations: {
    SET_listGames (state, value) {
      state.listGames = value
    },
    SET_totalGames (state, value) {
      state.totalGames = value
    },
    SET_game (state, value) {
      state.game = value
    },
    SET_nextGames (state, value) {
      state.nextGames = value
    }
  }
};

export default Game;